import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const BuildingSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default BuildingSVG;
